import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { isEmpty } from "lodash";
import { useContextSelector } from "use-context-selector";

import AuthContext from "../context/AuthContext";
import inviteIcon from "../assets/images/invite.webp";

const items = [
  { label: "Home", path: "/", icon: "#footer-home_ca6332ec" },
  { label: "Promotion", path: "/promotions", icon: "#footer-promo_8f0ad54e" },
  { label: "Invite", path: "/inviteFriends", protected: true },
  { label: "Reward", path: "/rewardCenter", icon: "#footer-reward_e67ac2f5", protected: true },
  { label: "Member", path: "/myaccount", icon: "#footer-member_aa9bb5fa", protected: true },
];

const FooterNew = () => {
  const user = useContextSelector(AuthContext, (context) => context.user);
  const location = useLocation();
  const navigate = useNavigate();

  const goToItem = (item) => {
    navigate(item.protected && isEmpty(user) ? "/login" : item.path);
  };

  const isActive = (item) => {
    if (item.path === "/") {
      return ["/", "/m/home", "/m/index.html"].includes(location.pathname);
    }

    const aliases = {
      "/promotions": ["/promotions", "/m/promotions", "/m/activity"],
      "/inviteFriends": ["/inviteFriends", "/m/inviteFriends"],
      "/rewardCenter": ["/rewardCenter", "/m/rewardCenter"],
      "/myaccount": ["/myaccount", "/m/myAccount"],
    };

    return (aliases[item.path] || [item.path]).includes(location.pathname);
  };

  return (
    <div className="footer-new">
      <nav className="footer-menu" aria-label="Main navigation">
        <div className="footer-menu-bg">
          <div className="footer-menu-list">
            {items.map((item) => (
              <div
                key={item.label}
                className={`footer-menu-item${isActive(item) ? " on" : ""}`}
                role="button"
                tabIndex={0}
                onClick={() => goToItem(item)}
                onKeyDown={(event) => event.key === "Enter" && goToItem(item)}
              >
                <div className="footer-icon">
                  {item.icon ? (
                    <svg className="am-icon am-icon-md">
                      <use xlinkHref={item.icon} />
                    </svg>
                  ) : (
                    <div className="footer-center">
                      <img className="center-icon" src={inviteIcon} alt="" />
                    </div>
                  )}
                </div>
                <div className="footer-menu-name">{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      </nav>
    </div>
  );
};

export default FooterNew;
